import React from 'react';
import { isNativeApp } from '../../utils/nativeApp';
import styles from './TalentNavbar.module.scss';

interface TalentPageTitleProps {
  title: string;
}

/** Mobile/native page title — scrolls with content (not sticky, no divider). Web uses navbar `pageTitle`. */
const TalentPageTitle: React.FC<TalentPageTitleProps> = ({ title }) => {
  if (!isNativeApp()) return null;
  return <h1 className={styles.pageTitleInContent}>{title}</h1>;
};

export default TalentPageTitle;
